import styled from 'styled-components';

export const Grid = styled.div<{ col: number; gap?: string; mobileCol?: number }>`
    display: grid;
    grid-template-columns: repeat(${({ col }) => col}, 1fr);
    gap: ${({ gap }) => gap ?? '20px'};

    ${({ theme, mobileCol }) => theme.mediaWidth.upToSmall`
        grid-template-columns: repeat(${mobileCol || 1}, 1fr);
    `};
`;
